export function dateToString(date: Date) {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
}
